['DOMContentLoaded', 'SidebarOpened', 'twz-popup-rendered'].forEach(ev => window.addEventListener(ev, () => {

  const tooltipToggles = document.querySelectorAll('[data-is-tooltip]');
  if(!tooltipToggles.length > 0) return

  tooltipToggles.forEach(toggle => toggle.addEventListener("click", (e) => {
    e.preventDefault();

    const trigger = e.currentTarget
    if(trigger.classList.contains('has--sidebar-open')) return

    trigger.classList.add('has--sidebar-open')

    console.log(trigger);

    new Sidebar({
      action : trigger.getAttribute('data-is-tooltip'),
      actionType : trigger.getAttribute('data-tooltip-type') ?? 'content',
      data: {
        products: trigger.getAttribute('data-products') ?? null,
        productID: trigger.getAttribute('data-productid') ?? null,
        pageID: trigger.getAttribute('data-pageid') ?? null,
        colorID: trigger.getAttribute('data-colorid') ?? null,
        link : trigger.getAttribute('data-tooltip-url') ?? null,
        trigger : trigger
      },
      onOpen: [
        trigger.getAttribute('data-tooltip-open') ?? ''
      ],
    })

  }));

}));

window.addEventListener('showSidebar',(e) => new Sidebar(e.detail))

class Sidebar {
    constructor(options) {

      this.hash = require('object-hash');

      this.options = {
        action : 'tooltip',
        className : 'twz-sidebar',
        overlayClassName : 'twz-sidebar-overlay',
        closeClassName : 'twz-sidebar-close',
        closeLabel : 'Sluiten',
        activeClass: 'is--expanded',
        onOpen: {},
        onClose: {},
      }
      this.options = { ...this.options, ...options};

      console.log(this.options)
      if(this.options.data.link && this.options.action === 'tooltip') {
        this.options.actionType = 'ajax';
      }


      switch(this.options.actionType) {
        case 'ajax':
          this.loadDataViaAjax();
          break;
        case 'content':
          this.loadDataViaHTML();
          break;
      }
    }

    loadDataViaHTML() {
      this.content = document.querySelector(`.${this.options.action}`).innerHTML;
      this.onDataComplete();
    }

    loadDataViaAjax() {

      const data = new FormData();
      data.set('action', this.options.action);

      Object.entries(this.options.data).forEach(([key, value]) => {
        data.set(key,value);
      });

      document.body.classList.add("loading");

      fetch(TWZ.ajaxurl, {
        method: 'POST',
        body: data
      })
      .then(res => res.json())
      .then((res) => {
        if (res.success) {
          document.body.classList.remove("loading");

          this.content = res.data.html || res.data.content;
          this.onDataComplete();
        }
      })
      .catch(err => {
        document.body.classList.remove("loading");
        console.error(err);
      })
    }

    create() {
      this.overlayContainer = document.createElement('div');
      this.overlayContainer.className = this.options.overlayClassName;
      this.overlayContainer.id = 'overlay_' + this.options.id;

      this.sidebarContainer = document.createElement('div');
      this.sidebarContainer.className = this.options.className;
      this.sidebarContainer.id = this.options.id;
      this.overlayContainer.appendChild(this.sidebarContainer);

      this.closeBtn = document.createElement('button');
      this.closeBtn.className = this.options.closeClassName;
      this.closeBtn.id = 'close_' + this.options.id;
      this.sidebarContainer.appendChild(this.closeBtn);
      this.sidebarContainer.insertAdjacentHTML('beforeend',this.content);

      document.body.appendChild(this.overlayContainer);
    }

    open() {
      document.body.classList.add('no-scroll');

      // Open that shit
      this.overlayContainer.classList.add(this.options.activeClass);

      // Always pop this event
      window.dispatchEvent(new CustomEvent('SidebarOpened',this.options));

      // open events
      this.options.onOpen.forEach(action => {
        window.dispatchEvent(new CustomEvent(action,{
          detail: this,
        }));
      });
    }

    close() {
      // remove overlay click event
      this.overlayContainer.removeEventListener('click',this.maybeClose);

      // remove esc key click close event
      this.overlayContainer.removeEventListener('keydown',this.maybeClose);
      this.closeBtn.removeEventListener('click',this.maybeClose);

      // remove sidebar
      this.overlayContainer.classList.add('is--removing');

      setTimeout(() => {
        // close it down
        this.overlayContainer.classList.remove(this.options.activeClass);
        this.overlayContainer.remove();

        if(!document.querySelector(`.${this.options.className}`)) {
          document.body.classList.remove('no-scroll')
        }
      }, 500);

      this.options.data.trigger.classList.remove('has--sidebar-open')

      // Always pop this event
      window.dispatchEvent(new CustomEvent('SidebarClosed',this.options));

      // close events
      Array.from(this.options.onClose).forEach(action => {
        window.dispatchEvent(new CustomEvent(action,this.options));
      })
    }

    onDataComplete() {
      // create the sidebar id from hasing the options
      this.options.id = this.hash(JSON.stringify(this.options));

      // create the sidebar
      this.create();

      // open the sidebar
      this.open();

      // add event listeners
      this.addListeners();
    }

    addListeners() {
      window.addEventListener('keydown',this.maybeClose.bind(this));
      this.overlayContainer.addEventListener('click',this.maybeClose.bind(this));
      this.closeBtn.addEventListener('click',this.close.bind(this));
    }

    maybeClose(e) {



      if (e instanceof MouseEvent || e instanceof PointerEvent) {

        
        if(e.target == this.overlayContainer) {
          this.close();
        }

      } else {
        if(e.key == 'Esc' || e.key == 'Escape') this.close();
      }
    }
}